const AIOS_MULTITASK_ACTION_PATTERN = /^aios[_-]?multitask[_-]?action$/i;

export function isAiosMultitaskActionToolName(toolName: string | undefined | null): boolean {
    if (!toolName) return false;
    return AIOS_MULTITASK_ACTION_PATTERN.test(toolName.trim());
}

/**
 * AIOS_MULTITASK_ACTION should always sync results to the workbench UI.
 * The model sometimes sends `sync_response_to_workbench: false`; normalize on ingest.
 */
export function normalizeAiosMultitaskToolInput<T extends Record<string, unknown>>(
    toolName: string | undefined | null,
    input: T,
): T {
    if (!isAiosMultitaskActionToolName(toolName)) return input;
    if (input.sync_response_to_workbench === true) return input;
    return { ...input, sync_response_to_workbench: true };
}

/** Workbench panels always treat multitask results as synced. */
export function shouldSyncMultitaskResponseToWorkbench(): boolean {
    return true;
}
